import OSSActionMenuCell from "./OSSActionMenuCell/OSSActionMenuCell";
import OSSUserNameCell from "./OSSUserNameCell/OSSUserNameCell";
import OSSCheckboxCell from "./OSSCheckboxCell/OSSCheckboxCell";
import { OSSKeyValueCell } from "./OSSKeyValueCell/OSSKeyValueCell";
import { OSSLinkCell } from "./OSSLinkCell/OSSLinkCell";

export default {
  OSSActionMenuCell,
  OSSCheckboxCell,
  OSSUserNameCell,
  OSSKeyValueCell,
  OSSLinkCell
};
